import React, { Component } from 'react';
import { connect } from 'react-redux';

import GoogleInviteModal from 'components/google-invite-modal';
import SlackInviteModal from 'components/slack-invite-modal';

const InviteModal = class extends Component {
  render() {
    const { showSlackInviteModal, showGoogleInviteModal } = this.props;

    if (showSlackInviteModal) {
      return <SlackInviteModal />;
    }

    if (showGoogleInviteModal) {
      return <GoogleInviteModal />;
    }

    return null;
  }
};

const mapStateToProps = state => {
  const { slack, google } = state;

  return {
    showSlackInviteModal: slack.show_invite_modal,
    showGoogleInviteModal: google.show_invite_modal,
  };
};

export default connect(mapStateToProps, null)(InviteModal);
